export default {"src":"/_next/static/media/spinner.b2ead382.svg","height":207,"width":207};